import React from 'react';
import { componentService } from 'js/services/component.service';

export const GoogleAuthButton = React.lazy(() => import(/* webpackChunkName: "google-auth-button" */ './GoogleAuthButton'));

componentService.registerWebContentComponents({ GoogleAuthButton });
